import React, { useEffect, useState, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Grid } from '@material-ui/core'

import {
  checkCodeAndHashValidForResettingPassword,
  resetPassword,
} from 'Reducers/Auth/actions'
import { PATHS } from 'Config/Routing/paths'

import SubmitButton from '../../../Components/Form/SubmitButton'
import InputPassword from '../../../Components/Inputs/InputPassword'
import BounceLoader from '../../../Components/BounceLoader'
import AuthWrapper from '../AuthWrapper'
import PasswordResetConfirmIllustration from '../../../Assets/Images/icons/PasswordResetConfirmIllustration'
import { AUTH_METHOD } from '../../../constants'
import { authorization } from '../../../Module/Auth/Auth'

const queryString = require('query-string')

const ResetPassword = ({ classes, location, history, ...props }) => {
  const [fields, setFields] = useState({
    password: { value: '', error: true },
  })
  const [disabled, setDisabled] = useState(true)

  const params = queryString.parse(location.search)
  const dispatch = useDispatch()

  const formSubmitted = useSelector(state => state.auth.formSubmitted)
  const errorMessage = useSelector(state => state.auth.errorMessage)
  const isCodeAndHashValid = useSelector(state => state.auth.isCodeAndHashValid)

  useEffect(() => {
    dispatch(
      checkCodeAndHashValidForResettingPassword(params.hash, params.code),
    )
  }, [])

  useEffect(() => {
    if (formSubmitted) {
      history.push(PATHS.main.resetPassSuccess)
    }
  }, [formSubmitted])

  useEffect(() => {
    const isFieldsHasError = Object.values(fields).some(({ error }) => error)

    if (isFieldsHasError) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [fields])

  const onChange = type => (value, error) => {
    setFields(prev => ({
      ...prev,
      [type]: {
        value,
        error: !value || !!error,
      },
    }))
  }

  const onSubmit = () => {
    const params = queryString.parse(location.search)
    dispatch(resetPassword(params.hash, params.code, fields.password.value))
  }

  const backToPlatform = () => {
    if (authorization.isLogged()) {
      history.push(PATHS.main.dashboard)
    } else {
      history.push(PATHS.main.login)
    }
  }

  return (
    <AuthWrapper>
      <Grid container spacing={4}>
        <Grid container item xs={12} md={6} className="h-100">
          <Grid
            container
            item
            xs={12}
            alignItems="center"
            justifyContent="center"
            className={'content has-large-padding h-100'}
          >
            <Box className={'content-inner'}>
              {isCodeAndHashValid ? (
                <Fragment>
                  <h1>Please set your new password:</h1>
                  <InputPassword
                    authMethod={AUTH_METHOD.OPPIZI}
                    value={fields.password.value}
                    onChange={onChange('password')}
                  />
                  <SubmitButton
                    className={'buttonNext'}
                    onClick={onSubmit}
                    disabled={disabled}
                  >
                    Confirm
                  </SubmitButton>
                </Fragment>
              ) : errorMessage ? (
                <Fragment>
                  <h1 className="text-center">{errorMessage}</h1>
                  <SubmitButton
                    className={'buttonNext'}
                    onClick={backToPlatform}
                  >
                    Return
                  </SubmitButton>
                </Fragment>
              ) : (
                <BounceLoader />
              )}
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <PasswordResetConfirmIllustration className={'illustration'} />
        </Grid>
      </Grid>
    </AuthWrapper>
  )
}

export default ResetPassword
